import { Component, OnInit } from '@angular/core';
import { PopupConfigService } from './popup-config.service';
import { isNullOrUndefined } from 'is-what';
import { IconService } from '../shared/icon.service';
import { ControlStatusService } from '../shared/control-status.service';
import {  TipoAlerta, Util } from '../shared/Util';
import { AlertaPainel, JsonReturn, ObjectParam } from '../shared/interface/generic-interface';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { PopupIconesComponent } from '../popup-icones/popup-icones.component';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'popup-config',
    templateUrl: './popup-config.component.html',
    styleUrls: ['./popup-config.component.css'],
    standalone: true,
    imports: [FormsModule, NgFor, NgIf, PopupIconesComponent]
})
export class PopupConfigComponent implements OnInit {

  exibirTelefone: boolean = false;
  exibirTelefoneCliente: boolean = false;
  obrigaFinalizarRoteiroAntes: boolean = false;
  bloquearMotoristaVersaoDesatualizada: boolean = false;
  guardarFoto: boolean = false;
  solicitarAssinatura: boolean = false;
  idConfiguracaoGeral: number = 0;
  listConfigGeral: any = [];
  horariosAtualizacoes = [
    {tempoMinutos: 5, descricao : '5 Minutos'},
    {tempoMinutos: 30,  descricao : '30 Minutos'},
    {tempoMinutos: 60,  descricao : '1 Hora'},
    {tempoMinutos: 0, descricao : 'Desativado'},
  ]
  tempoAtualizacao = this.horariosAtualizacoes[1];
  alertas: Array<AlertaPainel> = []
  
  constructor(private popupConfigService: PopupConfigService, public iconService: IconService, public controlStatus: ControlStatusService){}

  async ngOnInit()
  {
    try 
    {
      //Carrega configurações.
      const response = await this.popupConfigService.getConfiguracoesGerais();
      this.listConfigGeral = response;

      //Se não existirem, cria no banco.
      let existeConfigTelefone = this.listConfigGeral.find(x => x.Nome == "ExibirTelefoneVendedorAPP");
      if(isNullOrUndefined(existeConfigTelefone)){
        let resp = await this.addConfig('ExibirTelefoneVendedorAPP', "Exibir Telefone do Vendedor no Aplicativo","Validação", "Bool", "true", "true");
        this.listConfigGeral.push(resp[0]);
      }
      let existeGuardarFoto = this.listConfigGeral.find(x => x.Nome == "GuardarFotoFinalizacaoEntrega");
      if(isNullOrUndefined(existeGuardarFoto)){
        let resp = await this.addConfig('GuardarFotoFinalizacaoEntrega', "Solicita uma foto do final da entrega no Aplicativo","Validação", "Bool", "true", "true");
        this.listConfigGeral.push(resp[0]);
      }
      let existeSolicitarAssinatura = this.listConfigGeral.find(x => x.Nome == "SolicitarAssinaturaFinalizacaoEntrega");
      if(isNullOrUndefined(existeSolicitarAssinatura)){
        let resp = await this.addConfig('SolicitarAssinaturaFinalizacaoEntrega', "Solicita a assinatura digital pelo Aplicativo ao final da entrega","Validação", "Bool", "true", "true");
        this.listConfigGeral.push(resp[0]);
      }
      let existeConfigIcones = this.listConfigGeral.find(x => x.Nome == "ConfigIcones");
      if(isNullOrUndefined(existeConfigIcones)){
        let resp = await this.addConfig('ConfigIcones', "Cores dos ícones escolhido pelo cliente","Cadastro", "objeto", JSON.stringify(this.iconService.corPadraoIcone), JSON.stringify(this.iconService.corPadraoIcone));
        this.listConfigGeral.push(resp[0]);
      }

      let existeListarPendentes = this.listConfigGeral.find(x => x.Nome == "ListarPendentes");
      if(isNullOrUndefined(existeListarPendentes)){
        let resp = await this.addConfig('ListarPendentes', "Lista apenas os roteiros pendentes do dia","Validação", "Bool", "false", "false");
        this.listConfigGeral.push(resp[0]);
      }

      //Popula campos da tela
      for (let i = 0; i < this.listConfigGeral.length; i++) {
        let config = this.listConfigGeral[i];
        //Switch case para facilitar adicionar futuras configurações. 
        let filtro = null;
        switch (config.Nome) {
          case 'ExibirTelefoneVendedorAPP':
            filtro = this.listConfigGeral.filter(x => x.Nome == "ExibirTelefoneVendedorAPP");
            if(filtro != null)
            {
              this.exibirTelefone = filtro[0].Valor == "1" ? true : false;
            }
            break;
          case 'ConfigIcones':
            filtro = this.listConfigGeral.filter(x => x.Nome == "ConfigIcones");
            if(filtro != null)
            {
              this.iconService.configuracao = filtro[0];
              this.iconService.corEscolhidaIcone = JSON.parse(filtro[0].Valor);
            }
            break;
          case 'ListarPendentes':
            filtro = this.listConfigGeral.filter(x => x.Nome == "ListarPendentes");
            if(filtro != null)
            {
              this.popupConfigService.configPendentes = filtro[0];
              this.controlStatus.mostrarApenasPendentes = filtro[0].Valor == '1' ? true : false;
            }
            break;
          case 'ExibirTelefoneClienteAPP':
              filtro = this.listConfigGeral.filter(x => x.Nome == "ExibirTelefoneClienteAPP");
              if(filtro != null)
              {
                this.exibirTelefoneCliente = filtro[0].Valor == "1" ? true : false;
              }
            break;     
          case 'FinalizarRoteiroAntesIniciarProx':
                filtro = this.listConfigGeral.find(config => config.Nome == "FinalizarRoteiroAntesIniciarProx");  
                this.obrigaFinalizarRoteiroAntes = filtro.Valor == "1" ? true : false;           
            break;
          case 'BloquearMotoristaVersaoDesatualizada':
                filtro = this.listConfigGeral.find(config => config.Nome == "BloquearMotoristaVersaoDesatualizada");  
                if (filtro) this.bloquearMotoristaVersaoDesatualizada = filtro.Valor == "1" ? true : false;
            break;            
        }
      }

      let contemTempoAtualizacao = this.listConfigGeral.some((conf: any) => conf.Nome == 'TempoDeAtualizacaoRadar')
      if(contemTempoAtualizacao){
        this.tempoAtualizacao =  this.horariosAtualizacoes.find((tmp) => tmp.tempoMinutos == this.listConfigGeral.find((conf) => conf.Nome == 'TempoDeAtualizacaoRadar')?.Valor)
      }

      await this.getAlertas();
    }
    catch (Error) 
    {
      console.log(Error);
    }
  }

  onResetarPosicoesClick() {
    document.getElementById("btnResetarPosicoes").click()
  }

  acaoConfirmar()
  {
    $('#popUp-Config').modal('hide');
    setTimeout(function()
    { 
      (<any>window).isRefresh = true;
      document.location.reload();
    }, 500);
  }

  async alterarConfig(valor, nome)
  {
    let config;
    let item = this.listConfigGeral.filter(x => x.Nome == nome);

    if (nome === 'GuardarFotoFinalizacaoEntrega'){
      this.solicitarAssinatura = !this.guardarFoto
    }else if(nome ==='SolicitarAssinaturaFinalizacaoEntrega'){
      this.guardarFoto =!this.solicitarAssinatura;
    }

    try {  
      if(!isNullOrUndefined(item) && item.length > 0){
        config = item[0];
        if(typeof valor == 'boolean'){
          valor = valor ? '1' : '0';
        }
        config.Valor = valor;
        let objParam: ObjectParam = {
          configuracaoGeral: config
        }
        await this.popupConfigService.updateConfiguracaoGeral(config.ConfiguracaoGeralID, objParam);
      } 
    } catch (error) {
      console.log(error);
    }
  }

  async addConfig(nome, descricao, grupo, tipoDado, valor, valorPadrao){
    let response: JsonReturn;
    let id: JsonReturn;
    try {
      let objParam: ObjectParam = {
        configuracaoGeral:  {Grupo: grupo, Nome:nome, Descricao: descricao, Valor: valor, ValorPadrao: valorPadrao, TipoDado: tipoDado}
      }
      //Salvar no banco o objeto novo.
      id = await this.popupConfigService.addConfiguracaoGeral(objParam);
      response = await this.popupConfigService.getConfiguracaoGeralId(id[0].ConfiguracaoGeralID);
    }catch(e){
      console.log(e);
    }
      return response;
  }

  calculoCodigoAcesso()
  {
    let d = new Date(),
        month = (d.getMonth() + 1),
        day = d.getDate(),
        year = d.getFullYear();
        
    return (day + month) * year;
  }  

  fecharConfigs(){
    this.controlStatus.popupConfig = false;
  }

  async onChangeTempoAtualizacao(evento){    
    this.tempoAtualizacao = evento;
    let config = this.listConfigGeral.find((config) => config.Nome == 'TempoDeAtualizacaoRadar');
    config.Valor = this.tempoAtualizacao.tempoMinutos.toString();
    let objParam: ObjectParam = {
      configuracaoGeral: config
    }
    await this.popupConfigService.updateConfiguracaoGeral(config.ConfiguracaoGeralID, objParam);
    
  }

  async getAlertas(){
    let response: any  = await this.popupConfigService.getAlertas();
    this.alertas = this.trataAlertas(response);
    this.alertas.sort((anterior, proximo) => {
      if (anterior.mostraSelect === proximo.mostraSelect) {
          return 0;
      }
      return anterior.mostraSelect ? -1 : 1;
  });
  }

  trataAlertas(alertas: Array<AlertaPainel>){
    alertas.forEach((alerta: AlertaPainel) => {
      alerta.options = this.selecionaCampoSelect(alerta.TipoAlerta)
      alerta.descricao = this.selecionaCampoDescricao(alerta.TipoAlerta)
      if(alerta.TipoAlerta == TipoAlerta.VoltoDepoisOuEntregaRecusada || alerta.TipoAlerta == TipoAlerta.CercaEletronica){
        alerta.mostraSelect = false
      }else{
        alerta.mostraSelect = true;
      }

      if(alerta.TipoAlerta == TipoAlerta.TemperaturaMaximaPermitida){
        this.popupConfigService.atualizaValoresTemperaturMaxima(alerta)
      }
    })

    return alertas;
  }

  selecionaCampoSelect(tipoAlerta: String){
    switch (tipoAlerta) {
      case TipoAlerta.TempoDeDescarga:
      case TipoAlerta.TempoDesconectado:
      case TipoAlerta.TempoParado:
        return [10,20,30,40,50,60]       
      case TipoAlerta.TemperaturaMaximaPermitida:
        return [-10,-5, 0,5,10]
      case TipoAlerta.DesvioDeRota:
        return [5,10,15,20]       
      case TipoAlerta.VoltoDepoisOuEntregaRecusada:
        return []       
      default:
        return []
    }
  }

  selecionaCampoDescricao(tipoAlerta: String): string {
    switch (tipoAlerta) {
      case TipoAlerta.TempoDesconectado:
      case TipoAlerta.TempoDeDescarga:
      case TipoAlerta.TempoParado:
        return ' minutos';
      case TipoAlerta.DesvioDeRota:
        return ' quilômetros';
      case TipoAlerta.VoltoDepoisOuEntregaRecusada:
        return '';
      case TipoAlerta.TemperaturaMaximaPermitida:
        return '°C'
      default:
        return '';
    }
  }

  async updateAlerta(alerta: AlertaPainel){
    let objParam: ObjectParam = {
      painelAlerta: alerta
    }

    if(alerta.TipoAlerta == TipoAlerta.TemperaturaMaximaPermitida){
      this.popupConfigService.atualizaValoresTemperaturMaxima(alerta);
    }
    await this.popupConfigService.updateAlerta(alerta.AlertaPainelID, objParam)
  }

  async atualizarValorAlerta(valor: string, alerta: AlertaPainel){
    let novoValor = valor.split(' ')[0].trim()
    alerta.Valor = novoValor;
    await this.updateAlerta(alerta);
  }


  
}